<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <b-table :busy="isBusy"
             :fields="fields"
             :items="filteredItems"
             sticky-header
             responsive
             no-border-collapse
             show-empty
        >
            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay notificaciones que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha procesado ninguna notificación
                </b-card>
            </template>

            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>
        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js'

export default {
    name: 'StatementNotificationTable',

    components:{
        AlertDismiss
    },

    data() {
        return {
            isBusy: false,
            items: [],
            searchQuery: '',

            fields: [
                {
                    key: 'sentStatus',
                    label: 'Enviado',
                    formatter: x => x ? 'Sí' : 'No'
                },
                { key: 'description', label: 'Descripción' },
                { key: 'sentByName', label: 'Nombre del revisor' },
                { key: 'sentByMail', label: 'Correo del revisor' },
                { key: 'declarantName', label: 'Nombre del declarante' },
                { key: 'declarantMail', label: 'Correo del declarante' },
            ]
        }
    },

    async mounted(){
        this.$eventBus.$on(EventNames.FilterPepStatementNotificationsAfterSearch, (query) => {
            this.isBusy = true;

            this.searchQuery = query

            this.isBusy = false;
        });

        this.$eventBus.$on(EventNames.PaginationFilterPepStatementNotifications, async (query) => {
            this.isBusy = true;

            const page = query.page - 1; //se resta 1 por que el indice comienza en 0
            const pageSize = query.pageSize;

            await this.getAllNotification(page, pageSize);

            this.isBusy = false;
        });
    },

    computed: {
        filteredItems() {
            let filtered = this.items;
            // Filtrar por búsqueda por nombre, apellido, etc.
            if (this.searchQuery) {
                filtered = this.filterForSearch(filtered, this.searchQuery)
            }

            return filtered;
        }
    },

    methods:{
        ...mapActions(["getAllPepSendStatementsByPage", "countPepSendStatement"]),

        filterForSearch(itemsToFilter, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();
            if (!normalizedQuery) {
                return itemsToFilter;
            }

            return itemsToFilter.filter(item => {
                const sentStatusStr = (item.sentStatus ? 'sí' : 'no').toLowerCase(); // Adjusted for Sí/No
                const description = (item.description || '').toString().toLowerCase();
                const sentByName = (item.sentByName || '').toString().toLowerCase();
                const sentByMail = (item.sentByMail || '').toString().toLowerCase(); // New field for search
                const declarantName = (item.declarantName || '').toString().toLowerCase();
                const declarantMail = (item.declarantMail || '').toString().toLowerCase();

                return sentStatusStr.includes(normalizedQuery) ||
                       description.includes(normalizedQuery) ||
                       sentByName.includes(normalizedQuery) ||
                       sentByMail.includes(normalizedQuery) ||
                       declarantName.includes(normalizedQuery) ||
                       declarantMail.includes(normalizedQuery);
            });
        },

        async getAllNotification(page, pageSize){
            this.items = []

            const result = await this.getAllPepSendStatementsByPage({
                page: page,
                pageSize: pageSize
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.items = [];
                return;
            }

            this.items = result.data.map(apiItem => ({
                id: apiItem.id,
                sentStatus: apiItem.sent,
                description: apiItem.description || '',
                sentByName: apiItem.declarantReviser?.name || 'N/A',
                sentByMail: apiItem.declarantReviser?.mail || 'N/A',
                declarantName: apiItem.statement?.declarant?.name || 'N/A',
                declarantMail: apiItem.statement?.declarant?.mail || 'N/A',
            }));
        },
    }
    
}
</script>
